'use client';

import Image from 'next/image';

const IntegrationsSection = () => {
  const integrations = [
    {
      src: '/icons/paystack.svg',
      alt: 'Paystack',
      className: 'paystack-logo',
    },
    {
      src: '/icons/slack.svg',
      alt: 'Slack',
      className: 'slack-logo',
    },
    {
      src: '/icons/zohopeople.svg',
      alt: 'Zoho People',
      className: 'zoho-people-logo',
    },
    {
      src: '/icons/zohobooks.svg',
      alt: 'Zoho Books',
      className: 'zoho-books-logo',
    },
  ];

  return (
    <section className="section-five" id="grow">
      {/* Integrations */}
      <div className="integrations-area">
        <div className="integrations-container">
          <p className="integrations-label">Integrations</p>

          <h2 className="integrations-title">
            Plays well with the tools you already run.
          </h2>

          <p className="integrations-description">
            Avetium Payroll connects with the HR, accounting and payment
            platforms your business relies on — so payroll data flows
            without duplicate entry or manual reconciliation.
          </p>

          <div className="integration-logos">
            {integrations.map((integration) => (
              <div
                className={`integration-logo ${integration.className}`}
                key={integration.alt}
              >
                <Image
                  src={integration.src}
                  alt={integration.alt}
                  width={100}
                  height={35}
                  priority
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA / Grow Section - Full Width */}
      <div className="cta-area">
        <div className="cta-container">
          {/* Left Content */}
          <div className="cta-content">
            <p className="cta-label">READY WHEN YOU ARE</p>

            <h2 className="cta-title">
              <span>Payroll made simple.</span>
              <br />
              Compliance made automatic.
            </h2>

            <p className="cta-description">
              Join businesses across Nigeria and Ghana running payroll
              on Avetium — a product of Avetium Technologies.
            </p>

            <div className="cta-buttons">
              <a href="/auth/register" className="primary-button">
                Get started free
              </a>

              <a href="#contact" className="secondary-button">
                Request a demo
              </a>
            </div>
          </div>

          {/* Dashboard Image - Full width, better positioning */}
          <div className="cta-image-wrapper">
            <Image
              src="/images/ipad-phone-img.png"
              alt="Avetium Payroll dashboard"
              width={600}
              height={450}
              className="cta-image"
              priority
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntegrationsSection;